import { UserEventHandler } from '@xylabs/pixel';
class CoinUserEventHandlerBase extends UserEventHandler {
}
export default CoinUserEventHandlerBase;
